import { SemanticVersion } from 'semver';

export const runtimeVersion = SemanticVersion.parse('1.0.0');

